var render, staticRenderFns
import script from "./Rename.vue?vue&type=script&lang=js&"
export * from "./Rename.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7fe66007",
  null
  
)

export default component.exports